// src/services/shop/walletService.ts

import { gameApi as api } from '../api';

const walletService = {
    /**
     * Obtiene el resumen de la billetera
     */
    getWalletSummary: async (userId: string, localId: string) => {
        try {
            const response = await api.get('/casino/wallet/summary', {
                params: { userId, localId }
            });
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || 'Error al obtener datos de la billetera');
        }
    },

    /**
     * Obtiene el historial de la billetera
     */
    getWalletHistory: async (userId: string, params: {
        startDate?: string;
        endDate?: string;
        page?: number;
        limit?: number;
    } = {}) => {
        try {
            const response = await api.get('/casino/wallet/history', {
                params: {
                    userId,
                    ...params
                }
            });
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || 'Error al obtener historial');
        }
    },

    /**
     * Marca una comisión como pagada
     */
    markCommissionAsPaid: async (commissionId: string, userId: string) => {
        try {
            const response = await api.post('/casino/wallet/mark-paid', {
                commissionId,
                userId
            });
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || 'Error al marcar comisión como pagada');
        }
    },

    /**
     * Formatea cantidad monetaria
     */
    formatAmount: (amount: number): string => {
        return new Intl.NumberFormat('es-PY', {
            style: 'currency',
            currency: 'PYG',
            minimumFractionDigits: 0
        }).format(amount);
    },

    /**
     * Formatea fecha
     */
    formatDate: (dateString: string): string => {
        return new Date(dateString).toLocaleDateString('es', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    },

    /**
     * Obtiene el tipo de badge para el estado
     */
    getStatusBadge: (status: string): { color: string; text: string; icon: string } => {
        switch (status.toLowerCase()) {
            case 'pendiente':
                return {
                    color: 'text-yellow-300',
                    text: 'Pendiente',
                    icon: '⌛'
                };
            case 'pagado':
                return {
                    color: 'text-green-300',
                    text: 'Pagado',
                    icon: '✓'
                };
            default:
                return {
                    color: 'text-gray-300',
                    text: status,
                    icon: '•'
                };
        }
    },

    /**
     * Calcula la diferencia en días entre fechas
     */
    getDaysDifference: (dateString: string): number => {
        const now = new Date();
        const date = new Date(dateString);
        const diffTime = Math.abs(now.getTime() - date.getTime());
        return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    }
};

export default walletService;